import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import uniqueId from 'react-html-id';

//var className , divClass;
class FinchButton extends Component {
    constructor(props){
        super(props);
        this.className = '';
        this.divClass = '';

        uniqueId.enableUniqueIds(this);
    }

    render(){

        if(typeof(this.props.buttonClasses)==='undefined' && typeof(this.props.test)==='undefined'){
            this.className  = 'button ';
        }else if(typeof(this.props.buttonClasses)==='undefined'){
            this.className  = 'button '+ this.props.test;
        }else{
            this.className  = 'button '+ this.props.buttonClasses + ' ' + this.props.test;
        }

        //this.className  = 'button';

        if(this.props.primary === true){
            this.className  += ' button-primary';
        }

        if(this.props.large === true){
            this.className  += ' button-large';
        }

        if(this.props.inactive === true){
            this.className  += ' inactive';
        }
        if(this.props.processing === true){
            this.className  += ' processing';
        }

        // logic for loading hook
        if(typeof(this.props.change)==='undefined'){
            this.divClass = 'finch-button ';
        }else{
            this.divClass = 'finch-button ' + this.props.change;
        }

        return(
            <div className={this.divClass} hidden = {this.props.hidden}>
                <button type='submit' className = {this.className } onClick={this.props.submit} data-tip data-for={`fb_tooltip_${this.nextUniqueId()}`}>
                    {this.props.text}
                    <p className="processing-hook">
                        <span className="fa fa-spinner fa-spin"> </span>
                    </p>
                </button>
                <ReactTooltip id={`fb_tooltip_${this.lastUniqueId()}`} 
                    type={this.props.tooltipType}
                    offset={this.props.tooltipOffset} 
                    effect="solid" 
                    place={this.props.tooltipPlace}
                    disable={!this.props.tooltip}>
                    {this.props.tooltip}
                </ReactTooltip>
            </div>
        )
    }
}

FinchButton.defaultProps = {
    tooltip: null,
    tooltipType: 'dark',
    tooltipPlace: 'bottom',
    tooltipOffset: {bottom: 0, top: 0, left: 0, right: 0}
}

FinchButton.propTypes = {
    tooltip: PropTypes.string,
    tooltipType: PropTypes.string,
    tooltipPlace: PropTypes.string,
    tooltipOffset: PropTypes.object
}

export default FinchButton;

